import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScholarshipManagementContainerComponent } from './containers/scholarship-management-container/scholarship-management-container.component';

const routes: Routes = [
  { path: '', component: ScholarshipManagementContainerComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScholarshipRoutingModule {}
